// ==============================|| PREFERENCES CONFIGURATION ||============================== //

/**
 * Centralized configuration for module preferences
 * Defines which module-key combinations should be stored and their default values
 */

export const PREFERENCES_CONFIG = {
  // Module: { Key: DefaultValue }
  Clients: {
    Status: 'active'
  },
  Centres: {
    Status: 'active',
    Payee: 'all'
  },
  Brokers: {
    Status: 'active'
  },
  Carriers: {
    Status: 'active'
  },
  Divisions: {
    Status: 'active',
    Client: 'all'
  },
  Dentists: {
    Status: 'active'
  },
  Specialists: {
    Status: 'active'
  },
  EmergencyDentists: {
    Status: 'active'
  },
  Expiring: {
    Status: 'active',
    SortBy: 'expiry_date',
    SortOrder: 'asc'
  },
  FeeGuides: {
    Year: new Date().getFullYear().toString(),
    Province: 'all',
    Type: 'all',
    PaymentType: 'all',
    Status: 'active',
    FFDP: 'all'
  },
  GroupPlans: {
    Status: 'active'
  },
  Members: {
    Status: 'active',
    Client: 'all',
    Division: 'all',
    Centre: 'all'
  },
  Payments: {
    Status: '',
    Type: '',
    Printed: '',
    Method: ''
  },
  Dependents: {
    Type: 'all',
    Status: 'active'
  },
  Claims: {
    Status: 'all'
  },
  GroupPlansExcludedProcedures: {
    Status: 'active'
  },
  Coverage: {},
  Global: {
    FontSize: 16
  },
  Users: {
    SortBy: 'first_name',
    SortOrder: 'asc'
  }
};

/**
 * Get default preferences for a specific module
 * @param {string} moduleKey - The module name (e.g., 'Clients')
 * @returns {object} Default preferences for the module
 */
export const getModuleDefaults = (moduleKey) => {
  return PREFERENCES_CONFIG[moduleKey] || {};
};

/**
 * Check if a module has any configured preferences
 * @param {string} moduleKey - The module name
 * @returns {boolean} True if module has preferences configured
 */
export const hasModulePreferences = (moduleKey) => {
  return moduleKey in PREFERENCES_CONFIG && Object.keys(PREFERENCES_CONFIG[moduleKey]).length > 0;
};

/**
 * Get all configured modules
 * @returns {string[]} Array of module names that have preferences configured
 */
export const getConfiguredModules = () => {
  return Object.keys(PREFERENCES_CONFIG).filter(module => 
    Object.keys(PREFERENCES_CONFIG[module]).length > 0
  );
};

/**
 * Get all keys for a specific module
 * @param {string} moduleKey - The module name
 * @returns {string[]} Array of preference keys for the module
 */
export const getModuleKeys = (moduleKey) => {
  return Object.keys(PREFERENCES_CONFIG[moduleKey] || {});
};

export default PREFERENCES_CONFIG;
